import { render, staticRenderFns } from "./ProcessNotification.vue?vue&type=template&id=2460d400&"
import script from "./ProcessNotification.vue?vue&type=script&lang=js&"
export * from "./ProcessNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports